import { Typography } from '@mui/material';
import { Error } from 'icons';

import { black } from '~/styles/colors';

import ErrorLayout from './ErrorLayout';

const MessageLineOne = () => (
  <Typography variant="h4">We apologize, but a server error has occurred.</Typography>
);

const MessageLineTwo = () => (
  <Typography variant="subtitle1" color={black[600]}>
    Try again later, or contact support if the issue persists.
  </Typography>
);

const Page403 = () => {
  return (
    <ErrorLayout
      MessageLineOne={MessageLineOne}
      MessageLineTwo={MessageLineTwo}
      Alert={Error}
    />
  );
};

export default Page403;
